import styled from 'styled-components';
import { TextInput } from '../../baseInputs/TextInput';
import { useScene } from '../../../../context/sceneContext';

export const TextVariableInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData({ text: undefined }, 'props');

  const updateText = (value?: string) =>
    scene.updateSelectedElementsData({ text: value }, 'props', 'textVariableInput');

  return (
    <Row>
      <TextInput label="Text" value={data.text} onChange={(newValue) => updateText(newValue)} />
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;
`;
